import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency'
import { NetworkIcon } from '@root/entities/network/ui'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type Props = {
  amount: BigNumber
  currency?: CurrencyModel | '$'
} & ClassNameProps

export const TableAmountCell: React.FC<Props> = ({
  className,
  currency,
  amount,
}) => {
  const renderCurrency = () => {
    if (!currency || currency === '$') {
      return undefined
    }
    if (CurrencyModel.isNativeOrWrapped(currency.network)(currency)) {
      return <NetworkIcon size={12} network={currency.network} />
    }
    return currency.ticker
  }

  return (
    <Root className={className}>
      <Numeric
        value={amount}
        preset="currency-amount-short"
        currency={currency === '$' ? '$' : undefined}
      />
      {renderCurrency()}
    </Root>
  )
}

const Root = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 2px;

  color: var(--text-11);
`
